exports.connect = function(opts, cb) {
	throw "TLS is not supported in the browser. Use WSS instead.";
}
